import classNames from 'classnames'
import { InputHTMLAttributes, ReactNode } from 'react'
import styles from './ButtonCheckbox.module.css'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  icon: ReactNode
  text: string
}

export const ButtonCheckbox = ({ id, icon, className, text, ...props }: Props) => {
  const cardClassName = classNames(styles.button, className)

  return (
    <label className={classNames(styles.container)}>
      <input type="checkbox" id={id} name={id} tabIndex={0} {...props} />
      <span className={cardClassName}>
        <span className={styles.icon}>{icon}</span>
        <span className={styles.text}>{text}</span>
      </span>
    </label>
  )
}
